const zh = {
  // 导航栏
  navbar: {
    HOME: '首页',
    ABOUTUS: '关于我们',
    BUSINESSINTRODUCTION: '业务介绍',
    LIVERATE: '实时汇率',
    NEWS: '最新资讯',
    CONTACTUS: '联系我们',

    OpenAnAccountOnline: '在线开户',

    UPDATERATE: '带您了解最新的汇率情况',
    CONTACTWAY: '联系方式',
    INVITECOOPERATION: '诚邀合作',
    COMPANYNEWS: '公司要闻',
    CURRENCYMARKETDYNAMIC: '汇市动态'
  },
  // 底部
  footer: {
    CONTACTUS: '联系我们',
    WEBSITENAVIGATION: '网站地图',
    ABOUTUS: '关于我们',
    OURSERVICES: '主营业务',
    NEWS: '最新资讯',
    LIVERATE: '实时汇率',
    CUSTOMERSERVICE: '客服热线',
    WECHAT: '微信客服号'
  },
  // 首页
  index: {
    SERVICES: '主营业务',
    NEWS: '最新资讯',
    GOLDMATENEWS: '公司要闻',
    MARKETINSIGHT: '汇市动态',
    KUNDAX: '坤达速汇',
    GOLDMATE: '中联汇兑',
    GOLDMATEGROUP: '中联集团',
    KUNDAGROUP: '坤达集团',
    REASONSFORCHOOSINGUS: '选择我们的理由',

    // 实施滚动汇率
    weBuyTt:'现汇卖出价',
    weSellTt:'现汇买入价',
  },
  // 关于我们
  aboutUs: {
    CompanyIntroduction: '公司介绍',
    JoinUs: '加入我们',
    OurPartner: '合作伙伴',
    ABOUTUS: '关于我们',
    OurAdvantages: '我们的优势'
  },
  // 主营业务
  services: {
    Remittance: '中联汇兑',
    ProductServices: '产品服务',
    MoneyLaunderingPolicy: '反洗钱政策',
    PrivacyProtection: '隐私保护',
    Property: '中联地产',
    Funding: '中联基金'
  },
  // 资讯详情
  infomationDetail: {
    HotTopics: '热门文章',
    ArticleSearching: '搜索文章名称',
    DateSearching: '搜索日期',
    Prvious: '上一篇',
    Next: '下一篇',
    SearchingArticle: '搜索文章',
    noResult: '搜索不到相关文章，换个关键词试试吧'
  },
  // 实时汇率
  exchangeRate: {
    ExchangeCalculator: '货币兑换计算器',
    Sell: '卖出',
    Buy: '买入',
    Rate: '*实时汇率，每两分钟更新一次',
    Calculate: '计算',
    Inverse: '反算',
    tips: '以上汇率仅供参考，每两分钟自动刷新一次',
    input: '请输入',
    select: '请选择',
    cashExchange:'外币现金兑换',
    enterCash:'请输入换算金额',
    realtimeRate:'实时汇率',
    transferService:'国际转账业务',
  },
  // 联系我们
  contactUs: {
    Australianoffice: '澳洲办事处',
    SydneyRetailBranch: '悉尼营业部',
    ContactUs: '联系我们',
    Name: '姓名',
    Phone: '电话',
    Email: '邮箱',
    Purpose: '您的来意',
    ContactNumber: '联系电话',
    message: '留言',
    Submitt: '提交',
    Address: '地址',
    EmailAddress: '邮箱地址',
    OpenTime: '营业时间',
    ContactWay: '联系方式',
    BusinessConsulting: '业务咨询',
    'Coo&Con': '合作联系',
    callTips: '您可以直接拨打我们的联系方式\n非常开心接到您的来电',
    cooTips: '请填写此表格并按确认按钮.\n我们会尽快回复你的',
    publicAccount: '坤达速汇公众号',
    storeName: '坤达Chatswood门店'
  },
  // 在线开户
  openAccount: {
    RemittanceForm: '汇款表格',
    CustomerRegistrationAuthorizationForm: '客户登记授权表',
    BusinessCustomerRegistrationForm: '企业开户信息表'
  },
  // 表格
  table: {
    firstName: '姓',
    lastName: '名',
    yourCompanyName: '您的企业名称',
    FillInTheEnterpriseNumber: '填写企业编号',
    YourCareer: '您的职业',
    FillInTheEmail: '填写邮箱',
    FillInThePhoneNumber: '填写手机号码',
    FillInTheCertificationType: '填写证件类型',
    FillInTheDocumentNumber: '填写证件号码',
    FillInTheFullAddress: '填写详细地址',
    FillOutThePurpose: '填写用途',
    FillInTheBenchmarkCurrency: '填写基准货币',
    FillInTheTargetCurrency: '填写目标货币',
    PaymentMethod: '支付方式',
    NameOfPayee: '付款人姓名',
    RelationshipWithSender: '与汇款人关系',
    ContactTelephoneNumber: '联络电话号码',
    FillInTheBankName: '填写银行名称',
    FillInTheBankAccountNumber: '填写银行账号',
    FillInTheBankAddress: '填写银行地址',
    FillInTheInternationalSettlementAccountNumber: '填写国际清算账户号',
    PleaseSelect: '请选择',
    FillInThePassportOrDriversLicenseIssuingAgency: '填写护照/驾照发行机构',
    FillInTheFullName: '填写全名',
    UploadIDPhotos: '上传证件照片',
    Front: '(正面)',
    Back: '(反面)',
    UploadPhotos: '上传照片',
    ClickOnTheUpload: '点击上传',
    // 客户授权认证表
    AccountName: '填写开户名',
    BankBranchCode: '填写银行支行代号',
    swiftCode: '填写银行代码',

    // 企业开户信息表
    registrationNumber: '填写企业注册号码',
    contractName: '填写联系人姓名',
    fax: '填写传真',
    position: '填写职位',
    name: '填写名字',
    datePicker: '年/月/日',
    license: '填写护照/驾照号码'


  },
  // 表单校验
  formData: {
    email: '邮箱不能为空',
    emailFormat: '输入邮箱格式不正确',
    type: '汇款人类型不能为空',
    firstName: '姓不能为空',
    lastName: '名不能为空',
    name: '姓名不能为空',
    birth: '出生年月不能为空',
    occupation: '职业不能为空',
    phone: '电话号码不能为空',
    idType: '证件类型不能为空',
    idNumber: '证件号码不能为空',
    expireDate: '有效期限不能为空',
    address: '详细地址不能为空',
    source: '资金来源不能为空',
    purpose: '汇款用途不能为空',
    baseCurrency: '基准货币不能为空',
    targetCurrency: '目标货币不能为空',
    paymentMethod: '付款方式不能为空',
    payeeName: '收款人姓名不能为空',
    relationship: '与汇款人关系不能为空',
    contactNumber: '联系电话不能为空',
    recipientAddress: '详细地址不能为空',
    bankName: '银行名称不能为空',
    bankAccountNumber: '账户号码不能为空',
    bankAddress: '银行地址不能为空',
    optionalCode: '国际清算账户号不能为空',
    customerType: '客户类型不能为空',
    customerIdType: '证件类型不能为空',
    customerIdIssue: '护照/驾照发行机构不能为空',
    frontPhotoFirst: '驾照正面不能为空',
    backPhotoFirst: '驾照反面不能为空',
    handPhoto: '本人护照自拍照不能为空',
    frontPhoto: '证件正面不能为空',
    backPhoto: '证件反面不能为空',
    proofType: '信件不能为空',
    proofPhoto: '银行对账单不能为空',
    otherFiles: '其他附件不能为空',
    customerName: '全名不能为空',
    signature: '客户签名不能为空',
    date: '日期不能为空',
    // 客户授权认证表
    gender: '性别不能为空',
    accountName: '开户名不能为空',
    bankBranchCode: '银行支行代号不能为空',
    swiftCode: '银行代码不能为空',

    // 企业开户信息表
    registrationNumber: '填写企业注册号码',

    // 企业开户信息表
    companyName: '公司名称不能为空',
    companyNumber: '企业注册号码不能为空',
    contractName: '联系人姓名不能为空',
    fax: '传真不能为空',
    position: '职位不能为空',
    license: '护照/驾照号码不能为空',
    licenseExpireDate: '护照/驾照有效期不能为空',


    signName: '请签上客户姓名',
    agreeTerms: '请同意隐私保护政策条款',


    agree: '我已阅读并同意',
    privacyPolicy: '《隐私保护政策条款》',
    confirmAbove: '，并确认上述信息和提供的文件真实无误。'
  },
  // date Picker Options
  datePicker: {
    today: '今天',
    yesterday: '昨天',
    aWeeksAgo: '一周前'
  }
}

export default zh



// WEBPACK FOOTER //
// ./src/project/i18n/langs/zh.js